import React from 'react'
import styled from 'styled-components'
import JobOfferCard from 'spa/member/components/JobOfferCard'
import { RecommendedJobOffersProps } from './types'
import { breakpoints } from 'spa/config/styled'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import Breadcrumb from "../../components/Breadcrumb";

const RecommendedJobOffersContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and ${props => props.theme.media.sm} {
    flex-direction: column-reverse;
  }
`

const RecommendedJobOffersContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 2.25rem;

  @media ${props => props.theme.media.md} {
    padding: 4rem 2.5rem 8rem;
  }
`

const Title = styled.h1`
  text-align: center;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.7;
  margin-bottom: 0;

  @media ${props => props.theme.media.md} {
    font-size: 2rem;
  }
`

const SubTitle = styled.div`
  text-align: center;
  padding: 1rem 0;
  font-size: .75rem;
  line-height: 1.7;

  @media screen and ${props => props.theme.media.md} {
    font-size: 1rem;
    padding-bottom: 2.5rem;
  }
`

const StyledJobOfferCards = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-content: center;
  gap: 1rem;
  
  @media screen and ${props => props.theme.media.md} {
    grid-template-columns: repeat(2, min(calc(50% - 1rem), 600px));
  }
`

const StyledAnchor = styled.a`
  color: ${props => props.theme.members.colors.appleGreen._90};
  font-weight: 700;
  text-decoration: underline;
  text-decoration-thickness: 1px;

  &:hover {
    color: ${props => props.theme.members.colors.appleGreen._90};
    text-decoration: none;
  }
`

export const StyledRecommendedJobOffers: React.FC<RecommendedJobOffersProps> = props => {
  const windowWidth = useWindowWidth()
  const isSp = windowWidth < breakpoints.sm

  return (
    <RecommendedJobOffersContainer>
      <RecommendedJobOffersContent>
        <Title data-cy="recommended-job-offers-title">{ isSp ? 'おすすめの案件一覧' : 'あなたにおすすめの案件特集'}</Title>
        <SubTitle>
          プロフィールに記載いただいた内容や希望条件をもとに{isSp ? <br /> : ''}おすすめの案件を集めました。<br />
          条件はプロフィールシートの<StyledAnchor href="/profile_sheet/information_disclosure">希望条件・スカウト設定</StyledAnchor>から編集{isSp ? <br /> : ''}できます。
        </SubTitle>
        <StyledJobOfferCards>
          {
            props.jobOffersWithInfo.map(jobOfferWithInfo => {
              return (
                <JobOfferCard
                  key={jobOfferWithInfo.detail.id}
                  jobOffer={jobOfferWithInfo.detail}
                  isFavorite={jobOfferWithInfo.isFavorite}
                  isApplied={jobOfferWithInfo.isApplied}
                  borderDirection="horizontal"
                />
              )
            })
          }
        </StyledJobOfferCards>
      </RecommendedJobOffersContent>
      <Breadcrumb breadcrumb="おすすめの案件特集" />
    </RecommendedJobOffersContainer>
  )
}
